<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
import router from '@/router/router'
export default {
  mounted() {
    this.handleResize()
    window.addEventListener('resize', this.handleResize)
  },
  created() {},
  methods: {
    handleResize() {
      const baseSize = 16
      const scale = (window.screen.width * window.devicePixelRatio) / 1920
      // const vh = window.innerHeight
      // document.documentElement.style.setProperty('--vh', `${vh}px`)
      // document.documentElement.style.setProperty('--vtop', `5vh`)
      this.$nextTick(() => {
        // console.log(baseSize * scale, 'baseSize / scale--------------')
        if ((window.devicePixelRatio == 2 || window.devicePixelRatio == 1.5) && window.screen.width >= 1440) {
          document.documentElement.style.fontSize = baseSize * scale * (window.screen.width / 1920) * 0.75 + 'px'
        } else if (window.devicePixelRatio == 2 && window.screen.width == 1260) {
          document.documentElement.style.fontSize = baseSize * scale * (window.screen.width / 1920) * 0.9 + 'px'
        } else {
          document.documentElement.style.fontSize = baseSize * scale * (window.screen.width / 1920) + 'px'
        }
      })
    },
  },
}
</script>
<style >
.el-dialog__body {
  color: #000 !important;
}
</style>
<style lang="less" >
@import './assets/tableList.less';

//滚动条的宽度
::-webkit-scrollbar {
  width: 8px;
  height: 10px;
}

//滚动条凹槽的颜色，还可以设置边框属性
::-webkit-scrollbar-track-piece {
  // background-color:#f8f8f8;  // 这个不要更加好看，如果要了这个样式，没有产生滚动条的时候都会有一个框在右侧
  border-radius: 2px;
}

//滚动条的设置
::-webkit-scrollbar-thumb {
  background-color: #dddddd;
  background-clip: padding-box;
  min-height: 28px;
  border-radius: 10px;
}

::-webkit-scrollbar-thumb:hover {
  background-color: #bbb;
}

html,
body {
  font-size: 14px;
  padding: 0 0;
  margin: 0 0;
  font: menu;
}
.el-message {
  font-size: 14px;
  /* 修改消息提示框的字体大小 */
}

#app {
  // font-size: @font-size;
}
</style>
